import { useNetInfo } from '@react-native-community/netinfo';
// eslint-disable-next-line import/no-extraneous-dependencies
import { isNil } from 'lodash';

const useNoInternet = () => {
    const { isConnected, isInternetReachable } = useNetInfo();

    // we have to check best case if the device is connected and also has internet both has to be true
    if (
        typeof isInternetReachable === 'boolean' &&
        typeof isConnected === 'boolean'
    ) {
        return {
            isInternetConnected: isConnected && isInternetReachable,
        };
    }
    // sometimes the response isInternetReachable is null, so we need to check this case, we use only the isConnected param

    if (
        typeof isConnected === 'boolean' &&
        typeof isInternetReachable !== 'boolean'
    ) {
        if (isConnected && isNil(isInternetReachable)) {
            return {
                isInternetConnected: isConnected,
            };
        }
    }

    // in the case where both is null, it means that they were not initialized yet, it is needed to not show NoInternetAlert on application start
    if (isNil(isConnected) && isNil(isInternetReachable)) {
        return {
            isInternetConnected: true,
        };
    }

    // default we return false if the first two cases are not valid.
    return {
        isInternetConnected: false,
    };
};

export default useNoInternet;
